import React from "react";
import { Datagrid, DeleteButton, EditButton, FunctionField, List, Loading, TextField, TextInput, useMutation, useRedirect } from "react-admin";
import Approved from '@material-ui/icons/Done';
import Rejected from '@material-ui/icons/Clear';

import { CollegiateEngravingResources } from "../util";
import ListActions from "../../Signet/ListActions";


const CustomEdit = ({ record: { id } }) => {
    const redirect = useRedirect();
    const [getDetails] = useMutation({
        type: "getOne",
        resource: CollegiateEngravingResources,
        payload: { id: id }
    });

    const handleEdit = async e => {
        e.preventDefault();
        getDetails();
        redirect(`/${CollegiateEngravingResources}/${id}`);
    };

    return <EditButton onClick={handleEdit} />;
};

const CollegiateEngravingList = props => {
    const { permissions } = props;

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");

    const activeRenderer = record => {
        const status = record.enabled;

        if(status == 1) return <Approved style={{ color: 'green' }}/>;
        if(status == 0 ) return <Rejected style={{ color: 'red' }}/>;
      };

    return (
        <List
            {...props}
            exporter={false}
            actions={
                <ListActions filters={[
                    <TextInput source="name" label="Name" defaultValue="" />,
                    <TextInput source="school" label="School" defaultValue="" />,
                    <TextInput source="sku_code" label="Sku Code" defaultValue="" />
                ]} />
            }
        >
            <Datagrid rowClick={null}>
                <TextField source="name" label="Name" />
                <TextField source="school" sortable={false} label="School" />

                <TextField source="sku_code" sortable={false} label="Sku Code" />
                <FunctionField source="enabled" sortable={false} label="Active" render={activeRenderer}/>

                {permissionsList.includes("delete_signet_data") && <CustomEdit />}
                {permissionsList.includes("delete_signet_data") && (
                    <DeleteButton label="" undoable={false} />
                )}
            </Datagrid>
        </List>
    );
};

export default CollegiateEngravingList;